<template>
  <div
    v-if="shouldRender && !consentGiven"
    class="fixed bottom-0 left-0 right-0 flex justify-center z-30 px-2"
  >
    <div
      class="w-full lg:w-[600px] bg-brand-first text-white p-4 lg:p-8 shadow-lg border border-solid border-white border-opacity-20"
      :class="{ 'rounded-t-lg': siteSettingsStore.roundCorner }"
      role="dialog"
      aria-modal="true"
      aria-describedby="cookie-consent-text"
      :aria-label="t('Cookie Notice')"
    >
      <div class="flex flex-col md:flex-row justify-between items-center gap-4">
        <div id="cookie-consent-text" class="text-base md:text-lg">
          {{ t("Cookie Message") }}
          <!-- <NuxtLink
            to="/cerez-politikasi"
            class="underline text-white hover:opacity-80 duration-300 text-base md:text-lg"
            target="_blank"
            >Detaylı bilgi</NuxtLink
          > -->
        </div>
        <div class="flex gap-4">
          <AtomsButton
            :label="t('Cookie Accept')"
            color="second"
            size="small"
            @click="acceptCookies"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useSiteSettingsStore } from "@/store/index";

// Delay rendering until mounted so SSR and client match.
const shouldRender = ref(false);
const consentGiven = ref(true);
const { t } = useI18n();
const siteSettingsStore = useSiteSettingsStore();

onMounted(() => {
  const stored = localStorage.getItem("cookieConsent");
  consentGiven.value = stored === "accepted";
  shouldRender.value = true;
});

const acceptCookies = () => {
  localStorage.setItem("cookieConsent", "accepted");
  consentGiven.value = true;
};
</script>
